import api from '@/api/modelPerformance'

const {
    getSeriesList,
    getVolumeRanking
} = api;

export default {
    namespaced: true,

    state: {
        tableLoading: false,
        seriesList: [],
        rankingData: {}
    },

    actions: {
        // 车系表现列表
        getSeriesList({ commit }, payload) {
            let {
                statistics_begin_date,
                statistics_end_date,
                platform
            } = payload
            
            commit('changeState', { name: 'tableLoading', data: true })

            return getSeriesList({
                statistics_begin_date,
                statistics_end_date,
                platform
            })
                .then((res) => {
                    commit('changeState', { name: 'tableLoading', data: false })
                    console.log('getSeriesList res', res)
                    commit('changeState', { name: 'seriesList', data: res.data })
                })
        },
        // 声量排行
        getVolumeRanking({ commit }, payload) {
            let {
                statistics_begin_date,
                statistics_end_date,
                series_id,
                platform
            } = payload
            return getVolumeRanking({
                statistics_begin_date,
                statistics_end_date,
                series_id,
                platform
            })
                .then((res) => {
                    console.log('getVolumeRanking res', res)
                    commit('changeState', { name: 'rankingData', data: res.data })
                })
        },
    },

    mutations: {
        changeState(state, payload) {
            let {
                data,
                name
            } = payload;
            state[name] = data;
        }
    }
}
